import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatError, MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { NgxMaskModule } from 'ngx-mask';

import { DayInputComponent } from '../../../../modules/day-input/day-input.component';
import { LocalisePipe } from '../../../../modules/pipes/localise.pipe';
import { ProductEnum } from '../../../authentication/models/product.enum';
import { User } from '../../../authentication/models/v1-api.interface';
import { AuthenticationService } from '../../../authentication/services/authentication.service';
import { FormControlNameExport } from '../../../directives/form-control-name-export.directive';
import { ProfileService } from '../../../profile/services/profile.service';
import { DisableAutofillDirective } from '../../../shared/directives/disable-autofill.directive';
import { GlobalConstantsService } from '../../../shared/services/global-constants.service';
import { SharedService } from '../../../shared/services/shared.service';
import { InviteSignupProcessService } from '../../services/invite-signup-process.service';

@Component({
  selector: 'app-invite-signup-process-details',
  templateUrl: './invite-signup-process-details.component.html',
  styleUrls: ['./invite-signup-process-details.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatError,
    MatIconModule,
    MatDatepickerModule,
    MatButtonModule,
    NgxMaskModule,
    DayInputComponent,
    DisableAutofillDirective,
    LocalisePipe,
    FormControlNameExport,
  ],
})
export class InviteSignupProcessDetailsComponent implements OnInit {
  public error = '';
  public loading = false;
  private readonly lestOneEmpty: Array<keyof User> = [
    'mls',
    'ssn',
    'dateOfBirth',
  ];

  constructor(
    public inviteSignupProcessService: InviteSignupProcessService,
    public globalConstants: GlobalConstantsService,
    private profileService: ProfileService,
    private sharedService: SharedService,
    private authenticationService: AuthenticationService,
  ) {}

  ngOnInit(): void {
    const user = this.authenticationService.getProfileState();
    if (
      !user.productIds.includes(ProductEnum.Advance) ||
      !this.lestOneEmpty.some((field) => !user[field] && user[field] !== false)
    ) {
      this.inviteSignupProcessService.nextStep();
      return;
    }
  }

  public async next(): Promise<void> {
    if (this.inviteSignupProcessService.detailsForm.invalid) {
      return;
    }

    this.loading = true;

    try {
      await this.inviteSignupProcessService.updateDetails().toPromise();
      if (
        this.authenticationService
          .getProfileState()
          .productIds.includes(ProductEnum.Payment)
      ) {
        this.inviteSignupProcessService.close.next();
      }
      this.inviteSignupProcessService.nextStep();
    } catch (e) {
      this.error = this.sharedService.getErrorText(e, true);
    }

    this.loading = false;
  }
}
